import { computed, makeObservable } from 'mobx';

import LazyLoadingKeyValueStore, {
  EventBasedTransport,
} from '@codefluegel/lazy-loading-key-value-store';
import { Video } from '../types/transport';

export default class VideoStore extends LazyLoadingKeyValueStore<Video> {
  constructor(transport: EventBasedTransport<Video>) {
    super(transport);
    // need to specify *private* observables explicitly
    makeObservable(this, {
      updateVideoCategory: false,
      allEntries: computed,
    });
  }

  get allEntries(): Video[] {
    return this.entriesArray;
  }

  updateVideoCategory(key: string, value: Video | null): Promise<void> {
    return this.transport.setEntry(key, value);
  }
}
